import Image from 'next/image'
import Link from 'next/link'
import { memo } from 'react'
import type { ComponentProps } from 'react'

// Logo with internal link
export const LogoAlt = memo(
  (props: Omit<ComponentProps<typeof Image>, 'src' | 'alt' | 'placeholder' | 'blurDataURL'>) => (
    <Link href='/' className='cursor-pointer'>
      <LogoImage {...props} />
    </Link>
  ),
)

// Logo image without link (for use inside other links)
export const LogoImage = memo(
  (props: Omit<ComponentProps<typeof Image>, 'src' | 'alt' | 'placeholder' | 'blurDataURL'>) => (
    <Image
      {...props}
      placeholder='blur'
      alt='RTSC logo'
      src='/logo.png'
      blurDataURL='data:image/jpg;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAGCAMAAADNLv/0AAAAAXNSR0IB2cksfwAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAAK5QTFRFwsHBoZKSw7e29+np9+zs+Pb27evr/fz87+7u+/z8l4iIjQ0JoQkM14WCymZjpoWEk42Ns7Kyc3Fxvby8momJnAsLnwkM2dnZzZWVwry8kI6PlpSV19bX5+bmk4mIWRANbSso3dzcz7a2uLe4lJOTwcDBi4mKzMvM19bWzcLC7OXk/fDw8vLy7+/v9PX18PDw8fLy/f39//39/enn/ezq/eHf5+Xl4eHh5eXl39/fu+ppxwAAABxJREFUeJxjZGCEAy4EUwTBlEMwNRBMIyj9/yIAGUQCoeTy7I8AAAAASUVORK5CYII='
      priority
      unoptimized={false}
    />
  ),
)

LogoAlt.displayName = 'LogoAlt'
LogoImage.displayName = 'LogoImage'
